import { render, staticRenderFns } from "./SwipesTab.vue?vue&type=template&id=736eaf3a&scoped=true"
import script from "./SwipesTab.vue?vue&type=script&lang=js"
export * from "./SwipesTab.vue?vue&type=script&lang=js"
import style0 from "./asset-split.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SwipesTab.vue?vue&type=style&index=1&id=736eaf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736eaf3a",
  null
  
)

export default component.exports